export default {
      id: "video-small-usage",
      viewBox: "0 0 12 13",
      url: __webpack_public_path__ + "img/icons.svg#video-small",
      toString: function () {
        return this.url;
      }
    }